import { Injectable } from '@angular/core';
import { CustomerAccountParameters } from '../../models/api/customer-account-parameters';
import { Devise } from '../../models/api/devise';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthentificationService } from '../api/authentification.service';
import { UserService } from '../api/user.service';
import { ThemeService } from './theme.service';

@Injectable({
  providedIn: 'root'
})
export class ParametersServiceMyFactory {

  customerAccountParameters!: CustomerAccountParameters;
  listCurrency:Devise[] = [];

  static URL = environment.urlServer;

	constructor( ) {
  }

  public getDevise():Devise{
    let c = this.listCurrency.find(x => x.ID_Devise == this.customerAccountParameters.ID_Devise);
    if(c)
      return c;
    else throw new Error("Currency is not initialized for this customer account !");
  }


}
